// EmployeeManager.js
import React, { useState, useEffect } from 'react';
import './EmployeeManager.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";

const PartnerDeleter = ({updateKey}) => {
    const [employees, setEmployees] = useState([]);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [alert, setAlert] = useState({ show: false, message: '', type: '' });

    const fetchEmployees = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllPartner`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEmployees(data.data);
                }
            });
    };

    useEffect(() => {
        fetchEmployees();
    }, [updateKey]);



    const handleDeleteConfirmation = () => {
        setIsModalOpen(true);
    };

    const handleDelete = async () => {
        setIsModalOpen(false);

        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlert({ show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error' });
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/DeletePartner`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`
                },
                body: JSON.stringify({ id: selectedEmployeeId })
            });

            if (response.ok) {
                fetchEmployees();
                setSelectedEmployeeId('');
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
            } else {
                setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
            }
        } catch (error) {
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
        }
    };

    const closeAlert = () => {
        setAlert({ ...alert, show: false });
    };

    return (
        <div className="employee-manager">
            <select value={selectedEmployeeId} onChange={e => setSelectedEmployeeId(e.target.value)}>
                <option value="">აირჩიეთ კომპანია</option>
                {employees.map(employee => (
                    <option key={employee.id} value={employee.id}>{employee.fullName}</option>
                ))}
            </select>
            <button onClick={handleDeleteConfirmation} disabled={!selectedEmployeeId}>კომპანიის წაშლა</button>

            {alert.show && <CustomAlert message={alert.message} type={alert.type} onClose={closeAlert} />}

            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleDelete}
            />
        </div>
    );
};

export default PartnerDeleter;
